import React from 'react'
import NavbarProjects from './NavbarProjects'
import BannerBackground from "../Assets/home-banner-background.png";



function Projects005() {

  const workInfoData = [
    {
      image: "../images/project0051.jpeg",
      title: null,
      text: "Nuestro equipo tecnico tiene capacidad para reparar una variedad the sistemas complejos",
    },
    {
      image: "../images/project0052.jpeg",
      title: null,
      text: "Brindamos servicio de mantenimiento para equipo industrial o maquinaria de construction",
    },
    {
      image: "../images/project0053.jpeg",
      title: null,
      text: "Comercializamos partes para diferentes sistemas hidraulicos como sellos, bombas y todo tipo de partes industriales",
    },
    {
      image: "../images/project0054.jpeg",
      title: null,
      text: "Fabricamos partes y hacemos customizaciones con la mas alta calidad de mano de obra y siempre siguiendo requerimientos",
    }
    
  ];


  return (
    <div className="home-container">
      <NavbarProjects />
      <div className="home-banner-container">
        <div className="home-bannerImage-container">
          <img src={BannerBackground} alt="" />
        </div>
      </div>
      <div className="home-text-section">
        <h1 className="primary-text">
          Especialistas en Sistemas Hidraulicos
        </h1>
      </div>


      <div className='cards'>
        <h1 className="secondary-text">
          Reparacion brazo hidraulico
        </h1>
        <div className="work-section-bottom">
          {workInfoData.map((data) => (
            <div className="work-section-info-single" key={data.title}>
              <div className="none">
                <img src={data.image} alt="" />
              </div>
              {data.title ? (<h2>{data.title}</h2>) : (<div></div>)}
              <p>{data.text}</p>
            </div>
          ))}
        </div>

      </div>


    </div>

  )
}

export default Projects005